export default __webpack_public_path__ + "static/media/prabu.d0ed1d08.png";